module.exports = __webpack_public_path__ + "img/write-letter.ad669943.jpg";